<template>
    <div class="column full-width">
        <div>
            <q-btn-group class="q-ma-sm toggle-axis-button">
                <q-btn
                    @click="axisType = 'duration'"
                    :color="axisType === 'duration' ? 'primary' : 'white'"
                    :text-color="axisType === 'duration' ? 'white' : 'black'"
                    :label="$t('Duration')"
                    no-caps
                />
                <q-btn
                    @click="axisType = 'count'"
                    :color="axisType === 'count' ? 'primary' : 'white'"
                    :text-color="axisType === 'count' ? 'white' : 'black'"
                    :label="$t('Occurrence')"
                    no-caps
                />
            </q-btn-group>
        </div>
        <div>
            <loss-chart
                :report="report"
                :comparisonReport="comparisonReport"
                :axisType="axisType"
                :facility="facility"
                :selectedGroupBy="selectedGroupBy"
            ></loss-chart>
            <loss-chart
                v-if="comparisonReport"
                :report="comparisonReport"
                :comparisonReport="report"
                :isComparison="true"
                :axisType="axisType"
                :facility="facility"
                :selectedGroupBy="selectedGroupBy"
            ></loss-chart>
        </div>
    </div>
</template>

<script>
import LossChart from './LossChart.vue';

export default {
    name: 'LossDashboard',
    components: { LossChart },
    props: {
        report: {
            type: Object,
            required: true
        },
        comparisonReport: {
            type: Object,
            required: false
        },
        facility: {
            type: Number,
            required: true
        },
        selectedGroupBy: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            // toggle axis type ('count' or 'duration')
            axisType: 'duration'
        };
    }
};
</script>

<style lang="scss" scoped>
.toggle-axis-button {
    height: 35px;
    max-width: 226px;
}
</style>
